import React, { useState } from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import DashboardNav from "../dashboardNav";
import "../style.scss";
import AddNewAddressForm from "./addNewAddressContent";

const AddNewAddress = () => {
  const [activeItem, setActiveItem] = useState(2);
  const onClickHandler = () => setActiveItem(2);

  return (
    <MDBContainer
      id={`account-dashboard-container`}
      fluid
      className="dashboard-container"
    >
      <MDBRow className="m-0 p-0 justify-content-between align-items-stretch">
        <MDBCol
          xl="3"
          lg="3"
          md="4"
          sm="12"
          xs="12"
          className="m-0 p-0 main-navbar-account"
        >
          <DashboardNav
            activeItem={activeItem}
            onClickHandler={onClickHandler}
          />
        </MDBCol>
        <MDBCol xl="9" lg="9" md="8" sm="12" xs="12" className="m-0 p-0">
          <AddNewAddressForm />
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default AddNewAddress;
